import { gql } from '@apollo/client/core'

export const CATEGORY_SEGMENT_DETAILED_ATTRIBUTES = gql`
  fragment categorySegmentDetailedAttributes on CategorySegment {
    hasAttachments
    hasAttributeSegmentations
  }
`
